import { render } from "./DonorSpecialMeal.vue?vue&type=template&id=621c0860"
import script from "./DonorSpecialMeal.vue?vue&type=script&lang=js"
export * from "./DonorSpecialMeal.vue?vue&type=script&lang=js"
script.render = render

export default script